export class CookieHelper {
    validateTdCookie(): boolean {
        const cookieName = "td-auth";
        const nameLenPlus = (cookieName.length + 1);

        const cookie =
            document.cookie
                .split(';')
                .map(c => c.trim())
                .filter(cookie => {
                    return cookie.substring(0, nameLenPlus) === `${cookieName}=`;
                })
                .map(cookie => {
                    return decodeURIComponent(cookie.substring(nameLenPlus));
                })[0] || null;

        const isAdmin = cookie == "1";
        return isAdmin;
    }
}